<template>
  <div>
    <div v-if="!carrinhos.length" align="center" class="headline">
      O carrinho está vazio.
    </div>
    <v-card class="mt-5 card-shadow"
            v-for="fornecedor in fornecedores"
            :key="fornecedor.id">
      <v-card-text>
        <pxListagemCarrinhoFornecedores
                :finalizar="finalizar"
                :fornecedor="fornecedor"
                :disable-actions="disableActions"
                :remover-carrinho="removerCarrinho"
                :remover-produto="removerProduto"/>
        <v-row class="text--primary">
          <v-col cols="6">
            <span v-if="freteGratis(fornecedor).oferta">
              Oferta frete grátis a partir de: {{ freteGratis(fornecedor).valor | currency }}
            </span>
          </v-col>
          <v-col cols="6" class="text-right body-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                    <span v-on="on" class="orange--text text--darken-4 font-weight-bold">
                    Total: {{fornecedor.total | currency('R$', casaDecimal)}}
                    </span>
              </template>
              <span>Preço total</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  groupBy, forEach, first, sumBy,
} from 'lodash';
import { CasaDecimalUtils } from 'px-components';
import { getValorFreteGratis } from '../finalizacao/finalizacao-utils';
import ListagemCarrinhoFornecedores from './ListagemCarrinhoFornecedores.vue';

export default {
  components: { pxListagemCarrinhoFornecedores: ListagemCarrinhoFornecedores },
  props: {
    carrinhos: Array,
    disableActions: {
      default: false,
    },
    removerCarrinho: {
      type: Function,
      required: false,
      default: () => {
      },
    },
    removerProduto: {
      type: Function,
      required: false,
      default: () => {
      },
    },
    finalizar: {
      type: Function,
      required: false,
      default: () => {
      },
    },
  },
  data() {
    return {
      fornecedores: [],
    };
  },
  computed: {
    freteGratis() {
      return fornecedor => getValorFreteGratis(fornecedor.carrinhos);
    },
    casaDecimal() {
      const mappedProdutos = this.carrinhos.map(carrinho => carrinho.produtos.map(
        produto => produto.respostaCotacaoProduto.cotacaoProduto.produto,
      ));
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos[0]);
    },
  },
  methods: {
    agruparFornecedores(data) {
      this.fornecedores = [];
      if (!data) {
        return;
      }
      const temp = groupBy(data, i => `${i.respostaCotacao.fornecedor.id}-${i.comprador.id}`);
      forEach(temp, this.addFornecedor);
    },
    addFornecedor(v) {
      const cotacao = { ...first(v).respostaCotacao.cotacao };
      this.fornecedores.push({
        comprador: first(v).comprador,
        fornecedor: this.buildFornecedor(first(v).respostaCotacao.fornecedor, cotacao),
        carrinhos: v,
        total: sumBy(v, 'total'),
        frete: sumBy(v, 'frete'),
      });
    },
    buildFornecedor(fornecedor, cotacao) {
      if (cotacao.detalhesFornecedores && cotacao.detalhesFornecedores.length) {
        const detalheFornecedor = cotacao.detalhesFornecedores
          .find(detalhe => detalhe.fornecedor.id === fornecedor.id);
        if (detalheFornecedor) {
          return {
            ...fornecedor,
            codigoInterno: detalheFornecedor.codigoInterno ?? '',
          };
        }
      }
      return {
        ...fornecedor,
      };
    },
  },
  created() {
    if (this.carrinhos) {
      this.agruparFornecedores(this.carrinhos);
    }
  },
  watch: {
    carrinhos(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.agruparFornecedores(this.carrinhos);
    },
  },
};
</script>
